import { COVERGO_SAAS_DEV } from "../consts.js"

export const baTenant_dev = {
	"cover-health-ba-studio.quote.hk": {
		appConfig: {
			tenantId: "baTenant_dev",
			appId: "admin_portal"
		},
		envConfig: COVERGO_SAAS_DEV
	}
}
